import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { NAP, ASSETS, BOOK_URL } from "../lib/data";
import { TID } from "../lib/testIds";
import { trackBookClick } from "../lib/analytics";

export default function CallToActionStrip() {
  return (
    <section className="relative border-y border-[#262626] overflow-hidden">
      <div className="absolute inset-0 af-grid-noise opacity-50" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28 text-center">
        <p className="af-eyebrow mb-4">Get Help Today</p>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
          APPLIANCE BROKEN? <span className="text-[#DC2626]">WE'RE READY.</span>
        </h2>
        <p className="max-w-2xl mx-auto text-neutral-400 text-base lg:text-lg mb-10">
          Same-day dispatch across every service boundary — Chicago, Skokie, Elgin, Naperville and 30+
          more communities. Factory-trained technicians, parts on the truck, and a full parts & labor warranty.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href={NAP.phoneTel} className="af-btn-primary" data-testid={TID.ctaCallBtn}>
            <Phone size={18} /> {NAP.phoneDisplay}
          </a>
          <a
            href={BOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackBookClick("cta-strip")}
            className="af-btn-outline"
            data-testid={TID.ctaBookBtn}
          >
            Book Service Online <ArrowRight size={18} />
          </a>
        </div>
        <div className="mt-12 max-w-4xl mx-auto border border-[#262626] bg-[#0a0a0a]">
          <img
            src={ASSETS.section5}
            alt="Act Fast technicians on call"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
